import { render } from "./NewAccountViewModal.vue?vue&type=template&id=4c57d0f2&ts=true"
import script from "./NewAccountViewModal.vue?vue&type=script&lang=ts"
export * from "./NewAccountViewModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__